import React, { Dispatch } from 'react';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { Input } from 'src/components/Input';
import { ContractTermSection } from 'src/components/shared/ContractTermSection';
import { InputValidationRuleType } from 'src/constants';
import { IPrimeAMFRateCardValidationAction } from 'src/types/IPrimeAMFRateCardValidationAction';
import { IPrimeAMFRateCardValuesAction } from 'src/types/IPrimeAMFRateCardValuesAction';
import { IPrimeAMFRateCardValues } from 'src/types/IRateCard';

import { IPrimeAMFRateCardErrors } from '../../../rateCardValidationReducer';

interface IAddCapPRSDeduction {
    rateCardValues: IPrimeAMFRateCardValues;
    dispatchRateCardValues: Dispatch<IPrimeAMFRateCardValuesAction>;
    rateCardErrors: IPrimeAMFRateCardErrors;
    dispatchRateCardErrors: Dispatch<IPrimeAMFRateCardValidationAction>;
}

export const AddCapPRSDeduction: React.FC<IAddCapPRSDeduction> = ({
    rateCardValues,
    dispatchRateCardValues,
    rateCardErrors,
    dispatchRateCardErrors
}: IAddCapPRSDeduction) => {
    const errorMessage = rateCardErrors.primeContractTerms.prsDeductionCap;

    const handlePrsDeductionCapChange = (deductionCap: string): void => {
        dispatchRateCardValues({
            type: 'set_prs_deduction_cap',
            deductionCap: deductionCap
        });
    };

    const handleErrorMessageChange = (message: string): void => {
        dispatchRateCardErrors({
            type: 'validate_prs_deduction_cap',
            rateCardValues,
            message
        });
    };

    return (
        <ContractTermSection
            title={'Cap PRS deductions'}
            subTitle="Set allowable deduction caps for performance rights societies. By default allowable deductions will be 100% of royalties."
        >
            <Row widths="50%" alignmentVertical="top">
                <Column spacing="100">
                    <Text type="b200">Select deduction cap model</Text>
                    <Text type="b300">Percentage of Royalties</Text>
                </Column>
                <Column spacing="100">
                    <Input
                        label="Deduction cap percentage *"
                        value={(rateCardValues.primeContractTerms?.prsDeductionCap?.value ?? 1).toString()}
                        isEditMode={true}
                        type="number"
                        onChange={(newVal) => handlePrsDeductionCapChange(newVal)}
                        validationRules={[
                            InputValidationRuleType.Required,
                            InputValidationRuleType.Max8Char,
                            InputValidationRuleType.GreaterEqual0LessEqual1
                        ]}
                        handleErrMsgChange={handleErrorMessageChange}
                        errorMessage={errorMessage}
                    />
                </Column>
            </Row>
        </ContractTermSection>
    );
};
